import React from 'react';
import './ItemCardSkeleton.css';

/** Mirrors the block order of ItemCard: topbar, art on its own row, name, stats. */
const ItemCardSkeleton = ({ dense = false }) => {
    // Compact list: the card is only art and name, so the placeholder is too.
    if (dense) {
        return (
            <div className="item-card-skeleton item-card-skeleton--dense">
                <div className="skeleton-body">
                    <div className="skeleton-art"></div>
                    <div className="skeleton-line name"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="item-card-skeleton">
            <div className="skeleton-topbar">
                <div className="skeleton-line topbar-info"></div>
                <div className="skeleton-action"></div>
            </div>
            <div className="skeleton-body">
                <div className="skeleton-art"></div>
                <div className="skeleton-line name"></div>
                <div className="skeleton-line set"></div>
                <div className="skeleton-divider"></div>
                <div className="skeleton-stats">
                    <div className="skeleton-line long"></div>
                    <div className="skeleton-line medium"></div>
                    <div className="skeleton-line long"></div>
                    <div className="skeleton-line short"></div>
                    <div className="skeleton-line medium"></div>
                    <div className="skeleton-line long"></div>
                    <div className="skeleton-line short"></div>
                    <div className="skeleton-line medium"></div>
                    <div className="skeleton-line long"></div>
                </div>
                <div className="skeleton-divider"></div>
                <div className="skeleton-stats">
                    <div className="skeleton-line medium"></div>
                    <div className="skeleton-line short"></div>
                </div>
            </div>
        </div>
    );
};

export default ItemCardSkeleton;
